import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_7 = { colspan: "12" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "dialog-footer" }

import { ref } from "vue";
import { prefixLink } from "@/core/data/bcrDocs";
import DocsServices from "../../services/DocsServices";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricalDocuments',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const isLoading = ref(false);
const title = ref("");
const languages = ref<any>({});
const data = ref<any>([]);
const id = ref(0);
const criteria = ref<any>({
  page: 1,
  size: 15,
});

const site = ref("bvi");
const show = async (item) => {
  dialogRef.value = true;
  title.value = item.title;
  site.value = item.site;
  id.value = item.id;
  languages.value = item.languages;
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    criteria.value.page = _page;
    const response = await DocsServices.queryDocumentHistoryById(
      id.value,
      criteria.value
    );
    data.value = response.data;
    criteria.value = response.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const hide = () => {
  dialogRef.value = false;
  data.value = [];
  criteria.value = { page: 1, size: 15 };
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.viewDocumentsRecords') + ': ' + title.value,
    width: "1000",
    "align-center": "",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              modelValue: criteria.value.language,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.language) = $event)),
              placeholder: _ctx.$t('fields.selectLanguage'),
              disabled: isLoading.value,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (lang, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    label: lang,
                    value: key
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.version")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.language")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uploadedAt")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uploadedBy")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(ScaleLoader, { color: '#ffc730' })
                    ])
                  ])
                ]))
              : (!isLoading.value && data.value.length == 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                        _createElementVNode("td", null, _toDisplayString(item.language), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            type: "GMToneLiner",
                            "date-iso-string": item.updated_at
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.operator_info.name) + " - " + _toDisplayString(item.operator_info.email), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            loading: isLoading.value,
                            tag: "a",
                            href: _unref(prefixLink) + item.link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            plain: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.download")), 1)
                            ]),
                            _: 2
                          }, 1032, ["loading", "href"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})